// extracted by mini-css-extract-plugin
export default {"departments":"YF-z","departmentHeading":"ZF-z","departmentSection":"_F-z","departmentName":"aG-z","departmentLink":"bG-z","expandIcon":"cG-z"};